(function () {
  'use strict';

  var sourceSelector = '[data-dbe-blog-commerce-source]';
  var previewModuleSelector = '[data-dbe-commerce-preview-module]';

  function insertAfter(anchor, node) {
    if (!anchor || !node || !anchor.parentNode) return false;
    anchor.parentNode.insertBefore(node, anchor.nextSibling);
    return true;
  }

  function mountSource(source) {
    if (!source || source.dataset.dbeCommerceMounted === 'true') return;
    if (source.dataset.articleHandle !== 'nike-p-6000-2026-review') return;

    var article = document.querySelector('#main-article .post-content');
    if (!article) return;

    source.dataset.dbeCommerceMounted = 'true';

    article.querySelectorAll(previewModuleSelector).forEach(function (existing) {
      existing.remove();
    });

    var topModule = source.querySelector('[data-blog-commerce-module="top_availability"]');
    var contextModule = source.querySelector('[data-blog-commerce-module="mid_context"]');
    var endModule = source.querySelector('[data-blog-commerce-module="end_matrix"]');

    var oldTop = article.querySelector('[data-blog-commerce-module="intro_shop"]');
    var verdict = article.querySelector('[data-dbe-blog-cro="answer"]');
    if (topModule) {
      if (oldTop) oldTop.replaceWith(topModule);
      else insertAfter(verdict, topModule);
    }

    var stylingSignpost = article.querySelector('[data-dbe-p6000-section="review-styling-signpost"]');
    var sizingSignpost = article.querySelector('[data-dbe-p6000-section="review-sizing-signpost"]');
    if (contextModule) {
      insertAfter(stylingSignpost || sizingSignpost || topModule, contextModule);
    }

    var oldDecision = article.querySelector('[data-blog-commerce-module="review_decision"]');
    if (oldDecision) oldDecision.remove();

    var oldFinal = article.querySelector('[data-blog-commerce-module="review_final"]');
    if (endModule) {
      if (oldFinal) oldFinal.replaceWith(endModule);
      else article.appendChild(endModule);
    }

    if (!source.querySelector('.dbe-blog-commerce')) source.remove();
  }

  function mountAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(sourceSelector).forEach(mountSource);
  }

  mountAll(document);

  if (!window.__dbeP6000BlogCommerceSectionListener) {
    window.__dbeP6000BlogCommerceSectionListener = true;
    document.addEventListener('shopify:section:load', function (event) {
      mountAll(event.target || document);
    });
  }
})();
